export default __webpack_public_path__ + "static/media/icon_qualified.dcfcbbfc.svg";